module.exports = __webpack_public_path__ + "img/fc6ea8c.png";